module.exports = __webpack_public_path__ + "img/invite_1.72acbf00.svg";